import React, { useEffect, useRef, useState } from "react";

import {
  Row,
  Col,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

//Unform e componentes
import { Form } from "@unform/web";
import UInput from "@/frontend/componentes/unform/UInput";

//Context
import { useAuth } from "@/frontend/context/auth";

//Common
import { SITUACAO_USUARIO, TIPO_PERFIL } from "@/common/constantes";

//Util
import { ICONES_ACESSO, ICONES_BOTAO } from "@/frontend/utils/icones";
import { fn_getUsuario } from "@/frontend/utils/sessao";
import { fn_validarCamposObrigatorios } from "@/frontend/utils/form";
import { useEnterAsTab } from "@/frontend/utils/useEnterAsTab";

//API
import { api_autorizar } from "@/frontend/services/api/api_iud";
import { api_listar, ROTA_LISTAR } from "@/frontend/services/api/api_list";
import {
  api_findByPk,
  ROTA_FIND_BY_PK,
} from "@/frontend/services/api/api_find";

/**
 *  Apresenta a tela para autorizar uma ação em determinada tela
 */
function TAutorizacao_solicitacao({
  modalOpen,
  toggleModal,
  idTenant,
  idAutorizacao,
  setDadosAutorizacao,
  showMotivo = false,
  onSuccess,
}) {
  //### Context ###
  const { sessaoUsuario } = useAuth();

  //### USE REF ###
  const formRef = useRef(null);
  const domRef = useRef(null); // ref do wrapper DOM
  useEnterAsTab(formRef, domRef);

  //### USE STATE ###
  const [autorizacao, setAutorizacao] = useState(null);
  const [perfisLiberados, setPerfisLiberados] = useState([]);
  const [usuariosLiberados, setUsuariosLiberados] = useState([]);

  //### USE EFFECT ###
  //Inicialização da tela
  useEffect(() => {
    //Carrega a autorização de redefinir senha
    async function loadAutorizacao() {
      const autorizacao = await api_findByPk(
        ROTA_FIND_BY_PK.AUTORIZACAO,
        idAutorizacao,
      );
      setAutorizacao(autorizacao);
    }

    loadAutorizacao();
  }, []);

  //Ao carregar a autorização
  useEffect(() => {
    if (autorizacao) {
      //Carrega os perfis liberados e verifica se o usuário logado possui perfil liberado
      async function verificaPerfisLiberados() {
        const usuarioLogado = fn_getUsuario(sessaoUsuario);

        //Se a tela for chamada da ferramenta adm do system, precisa pegar o perfil do tenant em questão
        let filtroIdTenant = "";
        if (idTenant) {
          filtroIdTenant = `&id_tenant=${idTenant}`;
        }
        const perfisLiberados = await api_listar(
          ROTA_LISTAR.AUTORIZACAO_PERFIS_LIBERADOS,
          `id_autorizacao=${idAutorizacao}${filtroIdTenant}`,
        );
        setPerfisLiberados(perfisLiberados);

        const perfilUsuarioFind = perfisLiberados.find(
          (perfil) => perfil.id == usuarioLogado.perfil.id,
        );

        if (perfilUsuarioFind) {
          formRef?.current?.setFieldValue(
            "identificacao",
            usuarioLogado.identificacao,
          );

          if (showMotivo) {
            formRef?.current?.getFieldRef("motivo")?.current?.focus();
          } else {
            formRef?.current?.getFieldRef("senha")?.current?.focus();
          }
        } else {
          if (showMotivo) {
            formRef?.current?.getFieldRef("motivo")?.current?.focus();
          } else {
            formRef?.current?.getFieldRef("identificacao")?.current?.focus();
          }
        }

        //Carrega os usuários ativos dos perfis liberados
        if (perfisLiberados?.length > 0) {
          const idPerfis = perfisLiberados.map((perfil) => perfil.id).join(",");
          const usuarios = await api_listar(
            ROTA_LISTAR.USUARIO,
            `id_perfil=${idPerfis}&situacao=${SITUACAO_USUARIO.ATIVO}${filtroIdTenant}`,
          );
          setUsuariosLiberados(usuarios || []);
        }
      }

      verificaPerfisLiberados();
    }
  }, [autorizacao]);

  //### FUNCOES ###
  //Valida os dados do formulário ao submter
  function validarFormulario(body) {
    //Valida os campos obrigatórios
    return fn_validarCamposObrigatorios(formRef, body, ["nome"]);
  }

  //### EVENTOS ###
  //SUBMIT - Botão Confirmar
  //async function handleBotaoConfirmar() {
  async function handleSubmit(body) {
    //const body = formRef.current.getData();

    if (validarFormulario(body)) {
      //Envia para autorizar
      const usuario = await api_autorizar({
        ...body,
        id_tenant: idTenant || body.id_tenant,
        id_autorizacao: idAutorizacao,
      });

      //Se autorizou, seta os dados da autorização
      if (usuario) {
        //provisorio - vai ser substituido por onSuccess nas telas
        if (setDadosAutorizacao) {
          setDadosAutorizacao({
            id_autorizacao: autorizacao.id,
            id_usuario: usuario.id,
            motivo: body.motivo || null,
            token_autorizacao: usuario.token_autorizacao, //comprovante conferido pelo servidor na operação autorizada
          });
        }

        //depois vai ficar só esse sem if
        else if (onSuccess) {
          await onSuccess({
            id_autorizacao: autorizacao.id,
            id_usuario: usuario.id,
            motivo: body.motivo || null,
            token_autorizacao: usuario.token_autorizacao, //comprovante conferido pelo servidor na operação autorizada
          });
        }

        toggleModal();
      }
    }
  }

  return (
    <Modal isOpen={modalOpen} backdrop="static">
      <div ref={domRef} className="m-1">
        <Form ref={formRef} onSubmit={handleSubmit}>
          <ModalHeader toggle={toggleModal} className="titulo-tela-modal">
            Autorização
          </ModalHeader>

          <ModalBody>
            <Row className="mb-2">
              <Col>
                <div className="d-flex align-items-center">
                  <div className="w-100">
                    <UInput
                      name="nome"
                      disabled={true}
                      defaultValue={autorizacao?.nome?.toUpperCase()}
                    />
                  </div>

                  <div className="ms-2 mt-2">
                    <UncontrolledDropdown>
                      <DropdownToggle
                        size="sm"
                        color="secondary"
                        title="Perfis autorizados"
                      >
                        {ICONES_ACESSO.AUTORIZACAO_REQUERIDA}
                      </DropdownToggle>

                      <DropdownMenu style={{ cursor: "Default" }}>
                        <DropdownItem header>Perfis autorizados</DropdownItem>

                        <DropdownItem divider />

                        {perfisLiberados.map((perfil) => (
                          <DropdownItem
                            key={perfil.id}
                            style={{ cursor: "Default" }}
                          >
                            {perfil.nome}
                          </DropdownItem>
                        ))}
                      </DropdownMenu>
                    </UncontrolledDropdown>
                  </div>

                  <div className="ms-2 mt-2">
                    <UncontrolledDropdown>
                      <DropdownToggle
                        size="sm"
                        color="secondary"
                        title="Usuários autorizados"
                      >
                        {ICONES_ACESSO.USUARIOS}
                      </DropdownToggle>

                      <DropdownMenu
                        className="scroll-dropdown"
                        style={{ cursor: "Default" }}
                      >
                        <DropdownItem header>Usuários autorizados</DropdownItem>

                        {perfisLiberados
                          .filter((perfil) => perfil.tipo != TIPO_PERFIL.SYSTEM)
                          .map((perfil) => {
                          const usuariosPerfil = usuariosLiberados.filter(
                            (usuario) => usuario.id_perfil == perfil.id,
                          );

                          return (
                            <React.Fragment key={perfil.id}>
                              <DropdownItem divider />

                              <DropdownItem header>{perfil.nome}</DropdownItem>

                              {usuariosPerfil.length == 0 ? (
                                <DropdownItem text>
                                  Nenhum usuário ativo
                                </DropdownItem>
                              ) : (
                                usuariosPerfil.map((usuario) => (
                                  <DropdownItem
                                    key={usuario.id}
                                    style={{ cursor: "Default" }}
                                  >
                                    {usuario.matricula
                                      ? `${usuario.matricula} - ${usuario.nome}`
                                      : usuario.nome}
                                  </DropdownItem>
                                ))
                              )}
                            </React.Fragment>
                          );
                        })}
                      </DropdownMenu>
                    </UncontrolledDropdown>
                  </div>
                </div>
              </Col>
            </Row>

            {showMotivo && (
              <Row>
                <Col>
                  <UInput label="Motivo*" name="motivo" maxLength={100} />
                </Col>
              </Row>
            )}

            <Row>
              <Col>
                <UInput
                  name="identificacao"
                  label="Identificação*"
                  caseSensitive={true}
                  maxLength={35}
                />
              </Col>

              <Col>
                <UInput
                  //id="lastField"
                  type="password"
                  name="senha"
                  label="Senha*"
                  caseSensitive={true}
                  maxLength={20}
                  icone={ICONES_ACESSO.SENHA}
                />
              </Col>
            </Row>
          </ModalBody>

          <ModalFooter>
            <Button
              type="submit"
              name="btnConfirmar"
              color="primary"
              //onClick={handleBotaoConfirmar}
            >
              {ICONES_BOTAO.CONFIRMAR} Confirmar
            </Button>

            <Button name="btnFechar" color="secondary" onClick={toggleModal}>
              {ICONES_BOTAO.FECHAR} Fechar
            </Button>
          </ModalFooter>
        </Form>
      </div>
    </Modal>
  );
}

export default TAutorizacao_solicitacao;
